import { useEffect, useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/i18n";
import Home from "@/pages/Home";
import Galleria from "@/pages/Galleria";
import Yurax from "@/pages/Yurax";
import Attestati from "@/pages/Attestati";
import AreaRiservata from "@/pages/AreaRiservata";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ScrollManager = () => {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 350);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);
  return null;
};

const AuthCallback = () => {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = location.hash.split("session_id=")[1]?.split("&")[0];
    axios
      .post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true })
      .then((res) => navigate("/area-riservata", { state: { user: res.data }, replace: true }))
      .catch(() => navigate("/area-riservata", { state: { authError: true }, replace: true }));
  }, [location, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback-loading">
      <span className="text-[#0284C7] font-medium">Accesso in corso…</span>
    </div>
  );
};

const AppRouter = () => {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
      <ScrollManager />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/galleria" element={<Galleria />} />
        <Route path="/yurax" element={<Yurax />} />
        <Route path="/titoli" element={<Attestati />} />
        <Route path="/attestati" element={<Navigate to="/titoli" replace />} />
        <Route path="/area-riservata" element={<AreaRiservata />} />
      </Routes>
    </>
  );
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, anchors: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="grain">
      <Toaster richColors position="top-center" />
      <BrowserRouter>
        <LanguageProvider>
          <AppRouter />
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
